import { render } from "./CreateAvisoCobro.vue?vue&type=template&id=75db1340"
import script from "./CreateAvisoCobro.vue?vue&type=script&lang=js"
export * from "./CreateAvisoCobro.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__